<template>
  <div>
    <div class="mt-2 mb-2 title-float accent--text d-flex align-center">
      {{`${$tc('label.apuracao_plano_metas', 1)} - ${$tc('label.total_rebate', 1)}`}}
      <v-btn icon class="ml-2" @click="dialogRebate = true">
        <v-icon>info</v-icon>
      </v-btn>
    </div>
    <v-container fluid grid-list-md>
      <v-row>
        <v-col cols="12" md="12" class="pa-0">
          <v-card>
            <v-data-table
              :headers="cabecalhoGrupo"
              :items="linhasGrupo"
              disable-filtering
              disable-pagination
              disable-sort
              hide-default-footer>
              <template v-slot:item.statusAdesao="{ item }">
                {{item.metaMinima ? $t('label.dpm_minimo') : $t('label.nao_aderiu')}}
              </template>
              <template v-slot:item.meta="{ item }">
                {{getNumber(item.meta)}}
              </template>
              <template v-slot:item.faturado="{ item }">
                {{getNumber(item.faturado)}}
              </template>
              <template v-slot:item.pedidos="{ item }">
                {{getNumber(item.pedidos)}}
              </template>
              <template v-slot:item.projetado="{ item }">
                {{getNumber(item.projetado)}}
              </template>
              <template v-slot:item.atingimentoFaturado="{ item }">
                {{getPercent(item.atingimentoFaturado)}}
              </template>
              <template v-slot:item.atingimentoProjetado="{ item }">
                {{getPercent(item.atingimentoProjetado)}}
              </template>
              <template v-slot:item.statusGrupo="{ item }">
                 <div :class="classeStatusGrupo(item.statusGrupo)" v-if="item.metaMinima">
                  <span class="white--text">{{labelStatusGrupo(item.statusGrupo)}}</span>
                </div>
                <span class="text-center" v-else>-</span>
              </template>
              <template v-slot:body.append>
                <tr v-if="planoMetas.totais">
                  <td class="text-right" colspan="3" style="font-weight:bold">
                    {{getNumber(totais.metaTotal)}}
                  </td>
                  <td class="text-right" style="font-weight:bold">
                    {{getNumber(totais.faturadoPontuacao)}}
                  </td>
                  <td class="text-right" style="font-weight:bold">
                    {{getNumber(totais.pedidosPontuacao)}}
                  </td>
                  <td class="text-right" style="font-weight:bold">
                    {{getNumber(totais.projetadoPontuacao)}}
                  </td>
                  <td class="text-right" style="font-weight:bold">
                    {{getPercent(totais.atingimentoFaturado)}}
                  </td>
                  <td class="text-right" style="font-weight:bold">
                    {{getPercent(totais.atingimentoProjetado)}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialogRebate" max-width="600">
      <v-card>
        <v-card-title>
          {{$t('label.rebate')}}
        </v-card-title>
        <v-container>
          <v-row>
            <v-col>
              <span class="red--text">{{$t('label.rebate_info')}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" v-for="(verba, index) in verbas" :key="index">
              <input-money
                :label="verba.nome"
                v-model="verba.valor"
                :disabled="true"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getPercent, getNumber } from '../../../../produto/common/functions/helpers';
import InputMoney from '../../../../produto/shared-components/inputs/InputMoney';

export default {
  props: {
    planoMetas: Object,
  },
  components: {
    InputMoney,
  },
  data() {
    return {
      dialogRebate: false,

      cabecalhoGrupo: [
        {
          text: this.$t('label.grupo_cultura'),
          value: 'grupoCultura',
          align: 'start',
        },
        {
          text: this.$t('label.status_adesao'),
          value: 'statusAdesao',
          align: 'start',
        },
        {
          text: this.$tc('label.meta', 1),
          value: 'meta',
          align: 'end',
        },
        {
          text: this.$t('label.faturado'),
          value: 'faturado',
          align: 'end',
        },
        {
          text: this.$t('label.pedido'),
          value: 'pedidos',
          align: 'end',
        },
        {
          text: this.$t('label.projetado'),
          value: 'projetado',
          align: 'end',
        },
        {
          text: this.$t('label.atingimento_faturado'),
          value: 'atingimentoFaturado',
          align: 'end',
        },
        {
          text: this.$t('label.atingimento_projetado'),
          value: 'atingimentoProjetado',
          align: 'end',
        },
        {
          text: this.$t('label.status_atingimento'),
          value: 'statusGrupo',
          align: 'start',
        },
      ],
      linhasGrupo: [],
      totais: {},
      verbas: [],
    };
  },
  methods: {
    getPercent,
    getNumber,
    classeStatusGrupo(statusGrupo) {
      return {
        'label-verde': statusGrupo === 'ATINGIU',
        'label-laranja': statusGrupo === 'CUMPRIR_CARTEIRA',
        'label-vermelho': statusGrupo === 'MAIS_PEDIDOS',
        'text-center': true,
      };
    },
    labelStatusGrupo(statusGrupo) {
      if (statusGrupo === 'ATINGIU') {
        return this.$t('label.status_atingiu');
      }

      return statusGrupo === 'CUMPRIR_CARTEIRA'
        ? this.$t('label.status_cumprir_carteira')
        : this.$t('label.status_mais_pedidos');
    },
    preencherPlanoMetas() {
      const { linhas, totais, rebate } = this.planoMetas;

      this.preencheDadosTabela(linhas);
      this.preencheTotais(totais);
      this.preencheVerbas(rebate);
    },
    preencheDadosTabela(linhas) {
      this.linhasGrupo = linhas.map((linha) => ({ ...linha }));
    },
    preencheTotais(totais) {
      const {
        faturadoPontuacao,
        pedidosPontuacao,
        metaTotal,
        projetadoPontuacao,
        atingimentoFaturado,
        atingimentoProjetado,
      } = totais;
      this.totais = {
        metaTotal,
        faturadoPontuacao,
        pedidosPontuacao,
        projetadoPontuacao,
        atingimentoFaturado,
        atingimentoProjetado,
      };
    },
    preencheVerbas(rebate) {
      this.verbas = [...rebate];
    },
  },
  mounted() {
    this.preencherPlanoMetas();
  },
};
</script>
<style scoped>
.label-laranja {
  background-color: rgb(241, 196, 15) !important;
  border-color: rgb(241, 196, 15) !important;
}
.label-verde {
  background-color: rgb(26, 188, 156) !important;
  border-color: rgb(26, 188, 156) !important;
}
.label-vermelho {
  background-color: rgb(231, 76, 60) !important;
  border-color: rgb(231, 76, 60) !important;
}
</style>
